module.exports = __webpack_public_path__ + "img/40_61.1bd44ed6.png";